export interface IRouterService {
  goBack(): void;
  goTo(url: string): void;
  getActiveUrl(): string;
}
export const RouterServiceToken = Symbol.for('RouterServiceToken');
